<script setup lang="ts">
const storePickerDialog = useUiDialog('store-picker-dialog')
const { allocatedStore } = useStorelocator()
</script>

<template>
  <button
    class="store-picker-button"
    @click="storePickerDialog.open()"
  >
    <NuxtIcon name="icon:location" />
    <span v-if="allocatedStore">{{ allocatedStore.city }}</span>
    <span v-else>{{ $t('Select your store') }}</span>
  </button>
</template>

<style>
@import url("~layers/components/Store/Picker.css");
</style>
